import api from '../utilities/api';
import DateHelper from '@/utilities/date'


export default {
    organisations() {
        return api.v2.get(`organisations`);
    },
    getCertificateGeneratorLoginLink() {
        return api.v2.get(`organisations/certificate-generator/login-link`);
    },
    analyticsReport(organisationId, role)
    {
        let url = `organisations/${organisationId}/analytics`;

        if (role)
        {
            url += `?Role=${role}`;
        }

        return api.v2.get(url);
    },
    usersReport(organisationId, dateRange, limit = 10, page = 0, filter = '', sortBy = 'firstName', desc = true)
    {
        let sortDir = desc ? 'desc' : 'asc';
        sortBy = sortBy || 'firstName';
        let url = `organisations/${organisationId}/users/limit/${limit}/page/${page}?sortBy=${sortBy}&sortDir=${sortDir}&filter=${filter}`;

        if (dateRange) {
            url += `&from=${dateRange.from}&to=${dateRange.to}`;
        }

        return api.v2.get(url);
    },
    addUser(organisationId, request) {
        return api.v2.post(`organisations/${organisationId}/users`, request);
    },
    bulkImportUsers(organisationId, users) {
        return api.v2.post(`admin/organisations/${organisationId}/users/bulk-import`, { users });
    },
    usersReportCsv(organisationId, dateRange) {

        let url = `organisations/${organisationId}/users/csv`;
        let defaultFilename = 'users.csv'
        
        if (dateRange) {
            url += `?from=${dateRange.from}&to=${dateRange.to}`;
            defaultFilename = `users ${DateHelper.formatDateToDDMMYYYY(dateRange.from)} to ${DateHelper.formatDateToDDMMYYYY(dateRange.to)}.csv`;
        }
        
        return api.v2.get(url, {responseType: 'blob'}).then((resp) => {
            let result = document.createElement('a');
            let contentDisposition = resp.headers.get('Content-Disposition') || '';
            let filename;
            if (contentDisposition) {
                filename = contentDisposition.split('filename=')[1];
                filename = filename.replace(/"/g, "")
            } else {
                filename = defaultFilename;
            }

            return resp.blob()
                .then(function(data) {
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(data, filename);
                        return () => {};
                    } else {
                        result.href = window.URL.createObjectURL(data);
                        result.target = '_self';
                        result.download = filename;
                        return () => result.click();
                    }
                });
        });
    },
    getSettings(organisationId) {
        return api.v2.get(`organisations/${organisationId}/settings`);
    },
    updateSettings(organisationId, settings) {
        return api.v2.put(`organisations/${organisationId}/settings`, settings);
    },
    getTags(organisationId) {
        return api.v2.get(`organisations/${organisationId}/tags`).then((val) => val.body.tags);
    },
    getAllTags() {
        return api.v2.get(`organisations/tags`).then((val) => val.body.tags || val.body); // Handle direct array or wrapped response
    },
    updateTags(organisationId, tags) {
        return api.v2.put(`organisations/${organisationId}/tags`, { tags });
    },
    getCategories(organisationId) {
        return api.v2
          .get(`organisations/${organisationId}/categories`)
          .then((val) => val.body.tags);
    },
    updateCategories(organisationId, categories) {
        return api.v2.put(`organisations/${organisationId}/categories`, {
          tags: categories,
        });
    },
    getArrangedIn(organisationId) {
        return api.v2
          .get(`organisations/${organisationId}/arranged-in`)
          .then((val) => val.body.tags);
    },
    updateArrangedIn(organisationId, arrangedIns) {
        return api.v2.put(`organisations/${organisationId}/arranged-in`, {
          tags: arrangedIns,
        });
    }
}
